// extracted by mini-css-extract-plugin
export default {"account":"styles_account__Ce2Fa","stats":"styles_stats__aLdGo"};